// extracted by mini-css-extract-plugin
export default {"wrap":"Dt-z","fullWidth":"Et-z","items":"Ft-z","featureCss":"Gt-z","disabled":"Ht-z","imgCss":"It-z"};